import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=0cbf5f1e"
import script from "./AppCenter.vue?vue&type=script&lang=js"
export * from "./AppCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports